import { TASK_EXCLUDED_SYSTEM_CODES } from './constant';

export const getStatuses = (statuses = []) =>
  [...new Set(statuses.map(s => s?.name).filter(Boolean))];

/**
 * Filters tasks to exclude CLOSED and CANCELLED ones.
 * Uses exact systemLookupCode.name matching (not substring).
 * Used by the Subtasks accordion Active/All toggle.
 *
 * @param {Array} tasks - array of task DTOs
 * @param {Array} taskStatusData - lookup codes from Redux state.lookup.lookupData
 * @param {string[]} excludedCodes - system lookup code names to exclude (defaults to TASK_EXCLUDED_SYSTEM_CODES)
 * @returns {Array} filtered tasks
 */
export const filterActiveTasks = (tasks = [], taskStatusData = [], excludedCodes = TASK_EXCLUDED_SYSTEM_CODES) => {
    return tasks.filter(task => {
        const matched = taskStatusData?.find(item => item?.name === task?.status);
        return !excludedCodes.includes(matched?.systemLookupCode?.name);
    });
};